import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraOff1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCameraOff1"><Path fillRule="evenodd" clipRule="evenodd" d="M22.4144 21L3.00015 1.58582L1.58594 3.00003L4.58591 6H2V21H19.5859L21.0002 22.4142L22.4144 21ZM13.9755 15.3896C13.4133 15.7747 12.7329 16 12 16C10.067 16 8.5 14.433 8.5 12.5C8.5 11.7671 8.72529 11.0867 9.11041 10.5245L13.9755 15.3896Z" fill="currentColor"/><Path d="M22 17.7577L8.2758 4.03352L8.96482 3H15.0352L17.0352 6H22V17.7577Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraOff1;
